
import { globalBreak } from '@/styles/break';
import { SxProps} from '@mui/material';

export const headeruspLinkSX:SxProps = {
    height:40,
    justifyContent:'center',
    width:'100%',
    bgcolor:'#fff',
    '& #IT-Header-USP-eSpot_rv':{
        width:globalBreak({ desktop:'100%'})
    },
   '& .header-usps':{
        display:'flex',
        alignItems:'center',
        columnGap: 9,
        justifyContent: 'space-between',
        height:40,
        '& .usp-block':{
            display:'flex',
            alignItems:'center',
            fontSize: 12 , 
            columnGap:globalBreak({ mobile: '1px', desktop: '1px' }),
            '& .prefix-usp-text a':{
                width: 'max-content',
                display: 'block'
            }
        },
        '& .usp-text': {
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                maxWidth: '100px', 
                overflow: 'hidden',
            },
        '& .usp-block.header-usp-hide-mobile':{
            display: 'none'
        }
    },
    '& .hide-mobile':{
        display:globalBreak({mobile:'none',desktop:'flex'})
    }
};